var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-select',{attrs:{"items":_vm.civilState,"rules":_vm.rules,"value":_vm.value,"outlined":_vm.outlined,"dense":"","placeholder":"Estado civil"},on:{"input":_vm.setState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }